import { Typography } from '@mui/material';
import { useSlideContext } from '../../context';

import React from 'react';

export interface SlideParagraphProps {
  readonly children: React.ReactNode;
  style?: React.CSSProperties;
}

export function SlideParagraph({
  children,
  style,
}: SlideParagraphProps): React.ReactElement {
  const { theme } = useSlideContext();

  return (
    <Typography
      component="p"
      sx={{
        color: theme.colors.neutral,
        fontFamily: theme.fontFamily.body,
        fontWeight: theme.fontWeight.regular,
        fontSize: theme.fontSize.sm,
        ...style,
      }}
    >
      {children}
    </Typography>
  );
}
